// Shared constants for Drunk Fruit Event OS

export const BRAND = {
  name: "Drunk Fruit Mobile Bar",
  email: "events@drunkfruit-ca.com",
  instagram: "@Drunk.fruit",
  instagramUrl: "https://instagram.com/drunk.fruit",
  location: "Ontario, Canada — GTA Mobile Bar Service",
};

export const ALCOHOL_DISCLAIMER =
  "Alcohol is not included. Drunk Fruit Mobile Bar does not sell or purchase alcohol. The client is responsible for purchasing and providing all alcohol according to Ontario rules, venue rules, and event requirements. Quantities are estimates and may vary based on guest consumption.";

export const FIRE_NOTE =
  "For safety and insurance reasons, Drunk Fruit does not provide fire/flair bartending unless handled by a properly trained and insured specialist.";

export const IMAGES = {
  hero: "/photos/hero-bar.jpg",
  heroAlt: "/photos/setup.jpg",
  cocktail: "/photos/cups.jpg",
  cups: "/photos/cups.jpg",
  setup: "/photos/setup.jpg",
  service: "/photos/service.jpg",
  guests: "/photos/guests.jpg",
  brand: "/photos/brand-cover.jpg",
  mocktail: "https://images.unsplash.com/photo-1691200860596-70e10f1f7e95?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  juices: "https://images.unsplash.com/photo-1497534446932-c925b458314e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  garnish: "https://images.unsplash.com/photo-1619604394865-437a9fd6853c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  menuShot: "/photos/cups.jpg",
  wedding: "https://images.unsplash.com/photo-1712764995305-75422fbe0ecc?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  babyShower: "https://images.unsplash.com/photo-1782038522587-af4870bdb0a0?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  backyard: "/photos/setup.jpg",
  corporate: "/photos/hero-bar.jpg",
};

export const SERVICES = [
  { title: "Mobile Cocktail Bar", desc: "Full mobile bar with expertly crafted signature cocktails brought to your venue." },
  { title: "Mocktail Bar", desc: "Sophisticated zero-proof drinks — every cocktail can become a mocktail." },
  { title: "Bartender Service", desc: "Professional, presentable bartenders for a seamless guest experience." },
  { title: "Mobile Bar Rental", desc: "Elegant portable bar setup for your space, indoor or outdoor." },
  { title: "Full Bar Setup", desc: "Bar, supplies, garnishes, mixers, ice and premium presentation." },
  { title: "Custom Menu Creation", desc: "A tailored cocktail / mocktail menu designed around your event." },
  { title: "Kids Lemonade Bar", desc: "A colorful, alcohol-free bar the little guests will love." },
  { title: "Corporate Events", desc: "Polished service and optional glassware upgrade for corporate functions." },
  { title: "Weddings", desc: "Cocktail hour and reception service with an elevated, romantic touch." },
  { title: "Birthdays", desc: "Signature drinks that make any birthday feel special." },
  { title: "Baby Showers", desc: "Beautiful mocktails and a gentle, celebratory bar experience." },
  { title: "Backyard Events", desc: "Relaxed premium bar service for intimate backyard gatherings." },
  { title: "Private Parties", desc: "An unforgettable bar experience for your private celebration." },
  { title: "Outdoor Events", desc: "Weather-ready mobile bar service for open-air events." },
  { title: "Non-Alcoholic Bar", desc: "A full mocktail-only bar with fresh flavors and garnishes." },
  { title: "Beer, Wine & Bubbles Serving", desc: "Serving of beer, wine, champagne & prosecco you provide." },
];

export const HOW_IT_WORKS = [
  { step: 1, title: "Submit event details", desc: "Tell us about your event, guest count and vision." },
  { step: 2, title: "Choose up to 3 drinks", desc: "Select up to 3 signature cocktails/mocktails — up to 6 options when made both ways." },
  { step: 3, title: "Receive a professional quote", desc: "A clear, itemized quote tailored to your event." },
  { step: 4, title: "Approve the quote", desc: "Approve and lock in your details." },
  { step: 5, title: "Receive your documents", desc: "Contract, invoice/payment link, alcohol shopping list & custom menu." },
  { step: 6, title: "Pay 50% deposit", desc: "A 50% deposit reserves your date." },
  { step: 7, title: "We arrive & set up", desc: "Drunk Fruit arrives ~1 hour before service for setup." },
  { step: 8, title: "Enjoy the event", desc: "Sit back and enjoy a premium bar experience." },
];

export const MENU_PREVIEW = [
  { name: "Mango Mojito", tag: "Cocktail · Mocktail", desc: "White rum, fresh mango, mint, lime, soda." },
  { name: "Passion Fruit Mojito", tag: "Cocktail · Mocktail", desc: "Passion fruit, mint, lime, rum, soda." },
  { name: "Pineapple Jalapeño Spicy Margarita", tag: "Signature", desc: "Tequila, pineapple, jalapeño, lime, agave." },
  { name: "Lychee Martini", tag: "Elegant", desc: "Vodka, lychee, a whisper of rose." },
  { name: "Espresso Martini", tag: "Crowd Favorite", desc: "Vodka, espresso, coffee liqueur." },
  { name: "Spicy Guava Margarita", tag: "Signature", desc: "Tequila, guava, chili, lime." },
  { name: "Mango Margarita", tag: "Classic", desc: "Tequila, mango, lime, orange." },
  { name: "Vodka Spritz Peach", tag: "Refreshing", desc: "Vodka, peach, prosecco, soda." },
  { name: "Micheladas", tag: "Bold", desc: "Beer, lime, spices, chamoy rim." },
  { name: "Cosmopolitan", tag: "Classic", desc: "Vodka, cranberry, lime, triple sec." },
  { name: "Paloma", tag: "Refreshing", desc: "Tequila, grapefruit, lime, soda." },
  { name: "Moscow Mule", tag: "Classic", desc: "Vodka, ginger beer, lime." },
  { name: "Kids Lemonades", tag: "Kids · NA", desc: "Fresh lemonade in fun flavors." },
  { name: "Strawberry Mojito NA", tag: "Mocktail", desc: "Strawberry, mint, lime, soda." },
  { name: "Pineapple Coconut Colada", tag: "Mocktail", desc: "Pineapple, coconut cream, ice." },
  { name: "Peach & Blueberry Soda", tag: "Mocktail", desc: "Peach, blueberry, sparkling soda." },
];

export const GALLERY = [
  { label: "Mobile Bar Setup", img: "/photos/setup.jpg" },
  { label: "Premium Bar", img: "/photos/hero-bar.jpg" },
  { label: "Signature Cocktails", img: "/photos/cups.jpg" },
  { label: "Bartender Service", img: "/photos/service.jpg" },
  { label: "Happy Guests", img: "/photos/guests.jpg" },
  { label: "Mocktails", img: IMAGES.mocktail },
  { label: "Weddings", img: IMAGES.wedding },
  { label: "Garnishes", img: IMAGES.garnish },
  { label: "Baby Showers", img: IMAGES.babyShower },
];

export const EVENT_TYPES = [
  "Private Party", "Corporate Event", "Wedding", "Birthday Party", "Baby Shower",
  "Backyard Party", "Engagement Party", "Outdoor Event", "Kids Lemonade Bar",
  "Mocktail Event", "Anniversary", "Graduation", "Other",
];

export const CITIES = [
  "Mississauga", "Brampton", "Toronto", "Scarborough", "Markham", "Ajax", "Pickering",
  "Whitby", "Oakville", "Milton", "Georgetown", "Hamilton", "Barrie", "Aurora",
  "Dundalk", "Breslau", "Other",
];

export const HEAR_ABOUT = ["Instagram", "Google", "Referral", "Friend / Family", "Returning Client", "Event Planner", "Other"];

export const LEAD_STATUSES = [
  "New lead", "Contacted", "Waiting for details", "Quote in progress", "Quote sent",
  "Client interested", "Client declined", "Converted to event",
];

export const EVENT_STATUSES = [
  "Inquiry", "Quote sent", "Quote accepted", "Contract sent", "Deposit pending", "Deposit paid",
  "Confirmed", "Preparing", "Completed", "Cancelled",
];

export const QUOTE_STATUSES = ["Draft", "Sent", "Viewed", "Accepted"];

export const CONTRACT_STATUSES = [
  "Not generated", "Generated", "Sent", "Signed", "Deposit paid", "Fully paid", "Completed",
];

export const PAYMENT_STATUSES = [
  "Not invoiced", "Invoice sent", "Deposit pending", "Pending confirmation", "Deposit paid", "Balance pending",
  "Fully paid", "Refunded", "Cancelled",
];

export const MENU_STATUSES = ["Draft", "Requested", "Confirmed", "Generated", "Sent"];
export const DOC_STATUSES = ["Not generated", "Generated", "Sent"];

export const MENU_SELECTION_STATUSES = [
  "Not sent", "Selection guide sent", "Waiting for client choices",
  "Client choices received", "Menu confirmed", "Alcohol list generated",
];

export const TEMPLATE_VARIABLES = [
  "client_name", "event_date", "event_city", "guest_count", "quote_total", "deposit_amount",
  "balance_due", "payment_link", "quote_link", "contract_link", "invoice_link", "menu_link",
  "alcohol_list_link", "service_start_time", "setup_arrival_time", "selected_cocktails",
];

export const ALCOHOL_CATEGORIES = [
  "Spirits", "Liqueurs", "Wine", "Champagne / Prosecco", "Beer / Coolers", "Mixers",
  "Citrus", "Syrups", "Juices", "Garnishes", "Ice", "Cups", "Straws", "Napkins", "Optional",
];

export const KIDS_DRINK_IDEAS = [
  "Strawberry Mojito NA", "Mango Mojito NA", "Pineapple Coconut Colada",
  "Peach & Blueberry Soda", "Shirley Temple", "Lemonade Bar",
];

export const CAD = (n) => "$" + (Number(n) || 0).toLocaleString("en-CA", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export const resolveImg = (url) => (url && url.startsWith("/api") ? `${process.env.REACT_APP_BACKEND_URL}${url}` : url);

export const statusTone = (status) => {
  const s = (status || "").toLowerCase();
  if (["completed", "fully paid", "confirmed", "signed", "deposit paid", "converted to event", "client interested", "received"].some((x) => s.includes(x)))
    return "bg-olive/15 text-olive border-olive/30";
  if (["cancelled", "declined", "refunded"].some((x) => s.includes(x)))
    return "bg-destructive/10 text-destructive border-destructive/20";
  if (["pending", "sent", "quote", "contacted", "waiting", "requested", "invoice", "guide", "generated"].some((x) => s.includes(x)))
    return "bg-amber-500/10 text-amber-700 border-amber-500/20";
  return "bg-clay text-muted-foreground border-line";
};
